import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button } from "@mui/material";
import { AddButton } from "../../utils/commonComponent/Custom/Button";

const RequirementExcelDownload = ({
  requirementList = [],
   excelHeaders = [],
   buttonLabel="Export Excel",
}) => {

const handleExport = () => {
    if (!requirementList || requirementList.length === 0) return;

    // Format date dd/mm/yyyy
    const getFormattedDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const formattedData = requirementList.map((item) => {

      // Parse subTypeDetails into a map
      const subTypeMap = {};
      if (item.subTypeDetails) {
        item.subTypeDetails.split("||").forEach((entry) => {
          const [subType, detail] = entry.split(":|:");
          subTypeMap[subType] = detail;
        });
      }

      const row = {};

      excelHeaders.forEach((col) => {
        switch (col.key) {
          case "Type":
            row[col.header] = "ACH";
            break;

          case "date":
            row[col.header] = getFormattedDate();
            break;

          case "emailId":
            row[col.header] = "acc.srgeo@gmail.com";
            break;

            case "reqDate":
          row[col.header] = item.reqDate
            ? new Date(item.reqDate).toLocaleDateString("en-GB") // dd/mm/yyyy
            : "";
          break;

          case "debitAccountNumber":
            row[col.header] = "22506229250";
            break;

          default:
            // If the key matches a subType, use subTypeMap value
            row[col.header] = subTypeMap[col.key] ?? item[col.key] ?? "";
        }
      });

      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Requirements");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, "Requirement_List.xlsx");
  };

  return (
    <>
    <AddButton
      label={buttonLabel}
      onClick={handleExport}
      disabled={!requirementList?.length}
    />
  

</>
  );
};

export default RequirementExcelDownload;
